import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';
import { pxToRem } from '../../styles/utils';

import { Flexbox } from '../Flexbox';
import { UnstyledButton } from '../Button';

export const VideoWrapper = styled(Flexbox)<{
  fullwidth?: boolean;
  rounded?: boolean;
  variant?: 'default' | 'gl4c';
}>`
  margin-left: auto;
  margin-right: auto;
  position: relative;
  width: 100%;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: ${({ rounded }) => (rounded ? pxToRem(32) : 0)};

  ${mediaQueries[0]} {
    width: ${({ fullwidth = true }) => (fullwidth ? '100vw' : '100%')};
    height: ${({ fullwidth = true }) => (fullwidth ? '100vw' : '100%')};
    border-radius: ${({ rounded }) => (rounded ? pxToRem(16) : 0)};
  }

  ${mediaQueries.min} {
    width: ${({ fullwidth = true }) => (fullwidth ? '100vw' : '100%')};
    height: ${({ fullwidth = true }) => (fullwidth ? '100vw' : '100%')};
    border-radius: ${({ rounded }) => (rounded ? pxToRem(16) : 0)};
  }

  ${mediaQueries.tablet} {
    width: 100%;
    height: 100%;
    border-radius: ${({ rounded }) => (rounded ? pxToRem(32) : 0)};
  }
`;

export const PlayIcon = styled('svg')`
  cursor: pointer;
  max-width: 100%;
  z-index: 0;
  margin: auto;
`;

export const VideoButton = styled(UnstyledButton)`
  z-index: 1;
  outline: 0;
  position: absolute;
  width: ${pxToRem(58)};
  height: ${pxToRem(58)};

  .playIconBackground,
  .playIconCenter {
    transition: 0.2s fill ease;
  }

  &:hover .playIconBackground,
  &:focus .playIconBackground {
    fill: ${({ theme }) => theme.color.playIconCenter};
  }

  &:hover .playIconCenter,
  &:focus .playIconCenter {
    fill: ${({ theme }) => theme.color.playIconBackground};
  }

  ${mediaQueries.tablet} {
    width: ${pxToRem(80)};
    height: ${pxToRem(80)};
  }
`;
